import { AssetType, OperatedType } from '../../types';

export const enum ErrorCode {
  TOO_MANY_REQUESTS = 'TooManyRequests',
  BAD_REQUEST = 'BadRequest',
  INTERNAL_SERVER_ERROR = 'InternalServerError',
}

export const AssetTypeRequestMapping: Record<AssetType, string> = {
  [AssetType.ShortHeadline]: 'ShortHeadline',
  [AssetType.LongHeadline]: 'LongHeadline',
  [AssetType.Description]: 'Description',
};

export const OperatedTypeRequestMapping: Record<OperatedType, string> = {
  [OperatedType.TextRewriteWithDescription]: 'TextRewriteWithDescription',
  [OperatedType.TextRewriteWithTone]: 'TextRewriteWithTone',
  [OperatedType.TextFindSimilarText]: 'TextFindSimilarText',
};
